import { atom } from "recoil";

const FotoProfileState = atom<string>({
  key: "FotoProfile",
  default: "none",
});

export default FotoProfileState;
